module.exports = __webpack_public_path__ + "img/laporan.2b137686.png";